import type { IconDefinition } from "@simplybusiness/icons";
import {
  briefcase,
  buildingCircleCheck,
  carBuilding,
  houseChimney,
  user,
  users,
} from "@simplybusiness/icons";

export type Image =
  | "home-only"
  | "offsite"
  | "own-rent-space"
  | "sole-trader"
  | "partnership"
  | "limited-company";

export const isValidIconKey = (key: string): key is keyof typeof iconMap => {
  return key in iconMap;
};

export const iconMap: Record<Image, IconDefinition> = {
  "home-only": houseChimney,
  offsite: carBuilding,
  "own-rent-space": buildingCircleCheck,
  "sole-trader": user,
  partnership: users,
  "limited-company": briefcase,
};
